// Generated widget manifest
const widgetManifest = [
  {
    "dirName": "cart-widget",
    "componentName": "CartWidget",
    "tagName": "fluid-cart-widget",
    "propsJsPath": "./generated/cart-widget-props.js"
  },
  {
    "dirName": "banner-widget",
    "componentName": "BannerWidget",
    "tagName": "fluid-banner-widget",
    "propsJsPath": "./generated/banner-widget-props.js"
  },
  {
    "dirName": "lead-capture-widget",
    "componentName": "LeadCaptureWidget",
    "tagName": "fluid-lead-capture-widget",
    "propsJsPath": "./generated/lead-capture-widget-props.js"
  }
];
export default widgetManifest;